import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputsModule } from '../../../../common/inputs/inputs.module';
import { DialogService } from '../../../../../core/services/dialog.service';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'ling-create-whitelist-rule-dialog',
  templateUrl: './create-whitelist-rule-dialog.component.html',
  styleUrls: ['./create-whitelist-rule-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    InputsModule,
    TranslateModule,
    MatButtonModule,
    ReactiveFormsModule,
  ],
})
export class CreateWhitelistRuleDialogComponent {
  private readonly dialog = inject(DialogService);
  private readonly translateService = inject(TranslateService);
  protected readonly dialogData = inject(MAT_DIALOG_DATA).data;

  protected readonly submitButtonText = this.dialogData.isEdit
    ? this.translateService.instant('dialogs.createWhitelistRule.save')
    : this.translateService.instant('dialogs.createWhitelistRule.add');

  protected readonly rule = new FormControl(
    this.dialogData.rule?.rule ?? '',
    Validators.required
  );

  createRule(): void {
    if (this.rule.invalid) {
      return;
    }

    this.dialog.closeCurrent(this.rule.value);
  }
}
